import React, { useState, useEffect } from "react";
import { useModal } from "../../../../Components/Modal";
import Workspace from "../../../../APIController/Workspace";
import Text from "../../../../Components/Text";
import AddWorkspaceUserForm from "../Forms/AddWorkspaceUserForm";
import EditUserPermissionForm from "../Forms/EditUserPermissionForm";
import CrudPage from "../../../../Components/CrudPage";
import EditUserPasscodeermissionForm from "../Forms/EditUserPasscodeForm";

function UserManagement() {
    /* API Controller */
    const { fetchUserFromWorkspace, removeUser } = Workspace()

    const [workspaceUser, setWorkspaceUser] = useState([])
    //on startup
    useEffect(() => {
        fetchUserData()
    }, [])

    const roleLabel = (user, roleName) => {
        if (user.role === "ADMIN" || roleName === "ADMIN") return "Software Administrator"
        if (roleName === "OWNER") return "Eigentümer"
        if (roleName === "MANAGER") return "Manager"
        if (roleName === "EMPLOYEE") return "Mitarbeiter"
    }

    /* Set user */
    const fetchUserData = async () => {
        const data = await fetchUserFromWorkspace()
        setWorkspaceUser(data)
    }

    const formActions = async () => {
        await fetchUserData()
        closeModal()
    }

    /* Handler */
    const handleAddClick = async (e) => {
        e.preventDefault()
        openModal(<AddWorkspaceUserForm afterAction={() => formActions()} />)
    }

    const handleEditClick = async (e, user) => {
        e.preventDefault()
        openModal(<EditUserPermissionForm afterAction={() => formActions()} user={user} />)
    }

    const handlePasswordClick = async (e, user) => {
        e.preventDefault()
        openModal(<EditUserPasscodeermissionForm afterAction={() => formActions()} user={user} access={user.workspace[0]} />)
    }

    const handleDeleteClick = async (user) => {
        await removeUser(user.id)
        fetchUserData()
    }

    /* Modal helper */
    const { ModalView, openModal, closeModal } = useModal()

    const MainView = () => (
        <>
            <CrudPage
                title={"Mitarbeiter"}
                items={workspaceUser}
                crudActions={[
                    { type: "edit", color: "black", action: handleEditClick, icon: "edit" },
                    { type: "code", color: "black", action: handlePasswordClick, icon: "password" },
                    { type: "delete", color: "red", action: handleDeleteClick, icon: "trash" },
                    { type: "create", color: "bg-white", action: handleAddClick }]}
                displayMethod={(user) => (
                    <>
                        <div className="flex flex-row gap-2 flex-1">
                            <Text type="itemmain">{user.firstName}</Text>
                            <Text type="itemmain">{user.lastName}</Text>
                        </div>
                        <Text type="itemmain">{user.email}</Text>
                        <Text type="itemtext">{`${roleLabel(user, user.workspace[0].role)}`}</Text>
                        <Text type="itemtext">{`Mitarbeiter PIN ${user.workspace[0].numberCode}`}</Text>
                    </>
                )}
                allowedTarget={"employeesCount"}
                currentTargetValue={workspaceUser.length}
            />
            <ModalView classNames="w-auto" />
        </>
    )


    return (MainView())
}
export default UserManagement